import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { SatPopoverModule } from '@zerops/fe/popover';
import { ConfirmComponent } from './confirm.component';

@NgModule({
  declarations: [ ConfirmComponent ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    SatPopoverModule
  ],
  exports: [ ConfirmComponent ]
})
export class ConfirmModule { }
